import Conviva from './Conviva';

/*! (C) 2016 Conviva, Inc. All rights reserved. Confidential and proprietary. */
/*! This is sample code meant to illustrate proper Conviva integration in video applications. */
/*! This file should not be included in video applications as part of integrating Conviva. */

// Implements Conviva.TimerInterface for Chrome.

// setInterval does exactly what we need. We just need to return a function
// which cancels the timer when called.
// Some JavaScript implementations do not have setInterval, in which case
// you may have to write it yourself using setTimeout.

class Html5Timer implements Conviva.TimerInterface {
    public createTimer(
        timerAction: Conviva.TimerAction,
        intervalMs: number
    ): Conviva.TimerCancelFunction {
        let timerId = window.setInterval(timerAction, intervalMs);

        const cancelTimerFunc = (() => {
            if (timerId !== -1) {
                clearInterval(timerId);
                timerId = -1;
            }
        });

        return cancelTimerFunc;
    }

    public release(): void { /* */ }
}

export default Html5Timer;